import { useState } from "react";
import { useSite } from "@/lib/useSite";

export function BrandLogo({ location, className = "" }) {
  const { settings } = useSite();
  const [failed, setFailed] = useState(false);
  const source = settings?.brand_logo_url;
  const imageTestId = { header: "nav-logo-image", footer: "footer-logo-image" }[location] || `${location}-logo-image`;
  if (!source || failed) return <div data-testid={`${location}-logo-fallback`} className={`leading-none text-white ${className}`}><div className="font-display text-3xl italic">Mandalay</div><div className="mt-1 text-[8px] uppercase tracking-[.22em] text-white/65">Real Estate Media</div></div>;
  return <img src={source} onError={() => setFailed(true)} alt="Mandalay Real Estate Media" data-testid={imageTestId} className={`h-full w-full object-contain ${className}`} />;
}